import React, {useEffect, useState} from 'react';
import {useI18n} from '../../i18n';

const dismissalKey = 'vc_cookie_notice_dismissed';

const CookieNotice = () => {
    const {t} = useI18n();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            setVisible(window.localStorage.getItem(dismissalKey) !== '1');
        } catch {
            setVisible(true);
        }
    }, []);

    const dismiss = () => {
        try {
            window.localStorage.setItem(dismissalKey, '1');
        } catch {
            // The notice can still be dismissed for the current page.
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <aside
            aria-label={t('public.cookieNotice.label')}
            className="fixed bottom-4 left-4 z-[100] flex max-w-[calc(100vw-2rem)] items-center gap-2 rounded-full border border-neutral-700 bg-neutral-900/95 px-3 py-2 text-xs text-white shadow-lg backdrop-blur"
        >
            <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 shrink-0 text-orange-400">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 3a5.5 5.5 0 0 0 7.5 7.5A8 8 0 1 1 13.5 3Z"/>
                <circle cx="8.5" cy="8.5" r="1" fill="currentColor" stroke="none"/>
                <circle cx="7" cy="14" r="1" fill="currentColor" stroke="none"/>
                <circle cx="13" cy="17" r="1" fill="currentColor" stroke="none"/>
            </svg>
            <span>{t('public.cookieNotice.message')}</span>
            <button
                type="button"
                aria-label={t('public.cookieNotice.dismiss')}
                className="ml-1 grid h-5 w-5 shrink-0 place-items-center rounded-full text-neutral-400 hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-orange-400"
                onClick={dismiss}
            >
                <span aria-hidden="true">×</span>
            </button>
        </aside>
    );
};

export default CookieNotice;
